import { render, staticRenderFns } from "./InputHidden.vue?vue&type=template&id=a131c09a&"
import script from "./InputHidden.vue?vue&type=script&lang=js&"
export * from "./InputHidden.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports